export const ROOT_PATH = "/";
export const MANAGER_PATH = "/admin/manager";